import React, { PureComponent } from 'react';

import {
    View,
    StyleSheet
} from 'react-native';
import {
    JDTouchable,
    JDText,
    JDNativeSystem,
    JDImage
} from '@jdreact/jdreact-core-lib';
import { Link } from '@ltfe/ltfe-core-lib';

import img from '../../common/img';
import { pt, px, mta, tip, toMap } from '../../common/utils';
import Tag from './tag';

export default class TheatreAddr extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };

        this.tel = this.tel.bind(this);
        this.located = this.located.bind(this);
    }

    static defaultProps = {
        addrInfo: {
            tel: '4300000',
            cinemaName: '中传国际影城北京亦庄店',
            address: '大兴区经济技术开发区荣京东街大组广场S#',
            lon: '1.8',
            lat: 'aaa'
            // locatPress: () => {},
            // telPress: () => {}
            // cinemaTag: [] || ['退','改签']
        }
    }

    render() {
        const { addrInfo } = this.props;

        return (
            <View style={ st.addr }>
                <View style={ st.top }>
                    <Link style={ st.left } onPress={ this.toMovieList }>
                        <JDText numberOfLines={ 1 } style={ st.title }>{addrInfo.cinemaName}</JDText>
                        <JDText numberOfLines={ 1 } style={ st.addrtxt }>{addrInfo.address}</JDText>
                    </Link>
                    {/* 特色标签 */}
                    <Tag contentStyle={ { padding: 10, paddingLeft: pt(5), paddingBottom: pt(5), marginTop: 0 } } cinemaTag={ addrInfo.cinemaTag } key={ 2 } />
                </View>

                <View style={ [st.right, addrInfo.cinemaTag && { marginTop: pt(15) }] }>

                    <JDTouchable style={ st.button } onPress={ this.located }>
                        <JDImage style={ st.img } source={ img.located } />
                    </JDTouchable>
                    {
                        !!addrInfo.tel &&
                        <a style={ st.button } href={ 'tel:' + addrInfo.tel }>
                            <JDImage style={ st.img } source={ img.tel } />
                        </a>
                    }
                    {!!addrInfo.tel && <View style={ st.border } />}
                </View>
            </View>
        );
    }

    login() {

    }

    tel() {
        this.props.addrInfo.telPress && this.props.addrInfo.telPress();

        const { addrInfo } = this.props;

        mta('TicketTel', 'Detail', `${addrInfo.cinemaId}`);

        JDNativeSystem.callPhone(this.props.addrInfo.tel);
    }

    located() {
        this.props.addrInfo.locatPress && this.props.addrInfo.locatPress();

        const { addrInfo } = this.props;

        mta('TicketLocation', 'Detail', `${addrInfo.cinemaId}`);

        toMap(addrInfo);
    }

    toMovieList = () => {
        this.props?.toMovieList?.();
    }
}

const st = StyleSheet.create({
    addr: {
        justifyContent: 'center',
        width: pt(375),
        backgroundColor: '#fff',
        flexDirection: 'row'
    },
    top: {
        // flexDirection: 'row',
        justifyContent: 'space-between',
        padding: pt(10),
        paddingRight: 0
    },
    left: {
        width: pt(275),
        paddingLeft: pt(5)
    },
    title: {
        fontSize: pt(16),
        color: '#000',
        marginBottom: pt(3)
    },
    addrtxt: {
        fontSize: pt(12),
        color: '#898989'
    },
    right: {
        width: pt(100),
        flexDirection: 'row',
        justifyContent: 'flex-end',
        position: 'relative',
        paddingRight: pt(20),
        paddingBottom: pt(10)
    },
    border: {
        height: pt(30),
        position: 'absolute',
        borderRightWidth: px(1),
        borderColor: '#d4d4d4',
        left: pt(40),
        top: pt(5)
    },
    button: {
        height: pt(40),
        width: pt(40),
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex'
    },
    img: {
        width: pt(18),
        height: pt(21)
    }

});

module.exports = TheatreAddr;
